import { createSiteImage, getSiteImages } from 'slices/siteImageSlice'
import { createSiteNote, getSiteNotes } from 'slices/siteNoteSlice'
import type { ImageNoteAdapter } from '../commitImageUpload'
import { resolveImageType } from './locationImageAdapter'

export interface SiteImageAdapterArgs {
	dispatch: any
	userId: string
	siteId: string
}

/**
 * Evaluation site images and notes.
 *
 * Deliberately does NOT write `site.imageUrls`. EvaluationSiteForm replaces
 * that array wholesale on save, so anything written there would be wiped by the
 * next edit. Card and map thumbnails fall back to the newest SiteImage instead.
 */
export const siteImageAdapter = ({
	dispatch,
	userId,
	siteId,
}: SiteImageAdapterArgs): ImageNoteAdapter => ({
	createImageRow: async ({ image, note }) => {
		await dispatch(
			createSiteImage({
				userid: userId,
				siteid: siteId,
				uuid: image.upload.public_id,
				name: image.normalized.name ?? image.file.name,
				size: image.upload.bytes ?? 0,
				url: image.upload.secure_url,
				source: image.normalized.source ?? 'cloudinary',
				type: resolveImageType(image),
				note,
			}),
		).unwrap()
	},

	createNoteRow: async ({ html }) => {
		await dispatch(
			createSiteNote({
				siteid: siteId,
				note: html,
				parentid: null,
			}),
		).unwrap()
	},

	afterCommit: async () => {
		// Both, because a note carries its images inline and the same pictures
		// also land in the gallery.
		await dispatch(getSiteImages(siteId))
		await dispatch(getSiteNotes(siteId))
	},
})

export default siteImageAdapter
